import selectModel from "./model"

export default function selectCollection(state, engine, model, query) {
  const modelState = selectModel(state, engine, model)
  if (!modelState) {
    return null
  }
  const { queries } = modelState

  const ignoreQuery =
    model.collection &&
    (model.collection.cumulative || model.collection.ignoreQueryName)

  const advancedName =
    model.collection && model.collection.name ? model.collection.name : `{}`

  const key = ignoreQuery
    ? `${advancedName}{}`
    : `${advancedName}${JSON.stringify(query)}`
  return queries[key] || null
}
